var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tab-list tiles d-flex align-items-center"},_vm._l((_vm.labels),function(level,index){return _c('li',{key:index,attrs:{"data-item-index":index}},[_vm._v(_vm._s(level))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }